/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Setpoint_Not_Managed_By_PlcInputs */



/**
* | output |
* | --- |
* | "The setpoint is not managed by the GTB controller" |
*
* @param {Setpoint_Not_Managed_By_PlcInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const setpoint_not_managed_by_plc = /** @type {((inputs?: Setpoint_Not_Managed_By_PlcInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Setpoint_Not_Managed_By_PlcInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The setpoint is not managed by the GTB controller")
	return /** @type {LocalizedString} */ ("La consigne n'est pas gérée par l'automate GTB")
});